import { render } from "./Option.vue?vue&type=template&id=5dd244e0"
import script from "./Option.vue?vue&type=script&lang=js"
export * from "./Option.vue?vue&type=script&lang=js"
script.render = render

export default script